var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!!_vm.label)?_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_c('b-form-file',_vm._g(_vm._b({attrs:{"id":_vm.id,"browse-text":"Buscar archivo"}},'b-form-file',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }